import { ProtectedResourceScopes } from "@azure/msal-angular";

// const compassApiBaseUrl = 'https://localhost:44340/';
const compassApiBaseUrl = 'https://app-compasstoursapidev.azurewebsites.net';
//const compassApiBaseUrl = 'https://localhost:44340';
const compassAssetsBaseUrl = 'https://app-compasstoursapidev.azurewebsites.net/assets/';
const baseHref = 'https://app-compasstourswebsitedev.azurewebsites.net/';
const baseHrefDashboard = 'https://app-compasstoursdashboarddev.azurewebsites.net/';
const defaultScopes = ['https://compasstoursdev.onmicrosoft.com/api1/Compass.ReadWrite'];
const protectedResources: [string, Array<string| ProtectedResourceScopes> | null][] = [
  [`${compassApiBaseUrl}/orders/*`, defaultScopes],
  [`${compassApiBaseUrl}/customers/*`, defaultScopes],
  [`${compassApiBaseUrl}/carts/*`, defaultScopes],
  [`${compassApiBaseUrl}/bookingadditionalinfoforms/*`, defaultScopes],
  [`${compassApiBaseUrl}/bookings/*`, defaultScopes],
  // [`${compassApiBaseUrl}/excursionitineraries/*`, defaultScopes],
  [`${compassApiBaseUrl}/users/*`, defaultScopes],
  [`${compassApiBaseUrl}/reviews`, [...defaultScopes, {httpMethod: 'POST', scopes: null}]],  
  [`${compassApiBaseUrl}/reviews`, [...defaultScopes, {httpMethod: 'GET', scopes: null}]],  
  [`${compassApiBaseUrl}`, [...defaultScopes, { httpMethod: 'GET', scopes: null }]]
];

export const environment = {
  production: true,
  googleMapsApiKey: 'AIzaSyAcHmRsmWZXC4eCpom8pKhKtIVkMDOauCo',
  googleTagManagerId: 'GTM-WC7LZG3',
  compassApiBaseUrl,
  compassAssetsBaseUrl,
  baseHref,
  baseHrefDashboard,
  authEnv: 'compasstoursdev.b2clogin.com',
  ssrEnabled: true,
  b2cPolicies: {
    clientId: '04931b47-7673-48b4-918e-8d003fa36089',
    loginFailedPath: 'login-failed',
    names: {
        signUpSignIn: "B2C_1_CompassCreate_SignIn",
        forgotPassword: "B2C_1_ForgotPassword"
    },
    // authorities: {
    //     signUpSignIn: {
    //         authority: "https://mycompasstours.b2clogin.com/mycompasstours.onmicrosoft.com/B2C_1_CompassCreate_SignIn",
    //     },
    //     forgotPassword: {
    //         authority: "https://mycompasstours.b2clogin.com/mycompasstours.onmicrosoft.com/B2C_1_Reset",
    //     },
    //     signUp: {
    //         authority: "https://mycompasstours.b2clogin.com/mycompasstours.onmicrosoft.com/B2C_1_CompassSignUp",
    //     }
    // },
    authorities: {
      signUpSignIn: {
          authority: "https://compasstoursdev.b2clogin.com/compasstoursdev.onmicrosoft.com/B2C_1_CompassCreate_SignIn",
      },
      forgotPassword: {
          authority: "https://compasstoursdev.b2clogin.com/compasstoursdev.onmicrosoft.com/B2C_1_Reset",
      },
      signUp: {
          authority: "https://compasstoursdev.b2clogin.com/compasstoursdev.onmicrosoft.com/B2C_1_CompassSignUp",
      }
  },
    authorityDomain: "https://compasstoursdev.b2clogin.com/"
  },
  apiConfig: {
    userAttributesClientId: '5132e08b-0737-45a3-a425-e7f3e7abe532',
    scopes: ['https://compasstoursdev.onmicrosoft.com/api/Compass.ReadWrite'],
    uri: `${compassApiBaseUrl}/*`,
    authRequest: ['https://compasstoursdev.onmicrosoft.com/api/Compass.ReadWrite', 'user.read'],
    protectedResources
  },
  paymentConfig: {
    gateway: 'Cliq',//'Braintree'|'Square'|'Cliq'
    settings: {
      scriptUrl: "https://secure.cardflexonine.com/token/CollectCheckout.js",
      checkoutKey: "checkout_public_GW434Qsa5S6ACps94R3z328RzN8Z3n4S",
      postUrl: "https://secure.cardflexonline.com/api/transact.php",
    }
  },
  registerTravelAdvisorUrl: 'https://compasstoursdev.b2clogin.com/compasstoursdev.onmicrosoft.com/b2c_1_compasssignup/oauth2/v2.0/authorize?client_id=5f352bd7-4dfc-423a-b37a-91ed46ded984&scope=https%3A%2F%2Fcompasstoursdev.onmicrosoft.com%2Fapi%2FCompass.ReadWrite%20openid%20profile%20offline_access&redirect_uri=https%3A%2F%2Fwww.compasstoursdev.com%2F&client-request-id=5723ad96-ed80-4f11-bb87-50054acead35&response_mode=fragment&response_type=code&x-client-SKU=msal.js.browser&x-client-VER=2.22.0&x-client-OS=&x-client-CPU=&client_info=1&code_challenge=pJ3OAV5umDhOmup7Xd3MuJP4puwbl8NWN_cQFAjgvKg&code_challenge_method=S256&nonce=b62317a0-e14c-49bf-8af4-146a8c1224c3&state=eyJpZCI6ImM0MzI4YTU0LWVlNDAtNDQwNS05ZTRiLWIyYWVhNjJjODRhMCIsIm1ldGEiOnsiaW50ZXJhY3Rpb25UeXBlIjoicmVkaXJlY3QifX0%3D&travelagent=1'
};
